import { EventTypeEnum } from '@/types/replay/replay.types';

import { UserLight } from '../authent/login.types';

type BaseLog = {
  id: number;
  time: string;
  site: string;
  code: string;
  parameters: string[];
};

export interface InstructionLog extends BaseLog {
  type: LogTypeEnum.INSTRUCTION;
  instruction: string;
  author: UserLight | null;
}

export interface EventLog extends BaseLog {
  type: LogTypeEnum.EVENT;
  author: UserLight | null;
  name: string;
  startDate: string;
  observationType: EventTypeEnum;
  duration: number;
  comment: string;
  action: EventActionEnum;
}

export interface SystemLog extends BaseLog {
  type: LogTypeEnum.SYSTEM;
  action: SystemActionEnum;
}

export interface UserActionLog extends BaseLog {
  type: LogTypeEnum.USER_ACTION;
  action: UserActionEnum;
  author: UserLight | null;
}

export type HoloLog = InstructionLog | EventLog | SystemLog | UserActionLog;

export enum SystemActionEnum {
  NEW_ALERT = 'NEW_ALERT',
  // Other is a temporary value until we have more than one in this enum to avoid errors in the function getLogContent
  OTHER = 'OTHER',
}

export enum UserActionEnum {
  IS_INACTIVE = 'IS_INACTIVE',
  IS_ACTIVE = 'IS_ACTIVE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  USER_RESET = 'USER_RESET',

  INSTRUCTION = 'INSTRUCTION',

  ACKNOWLEDGE_NOTIFICATION = 'ACKNOWLEDGE_NOTIFICATION',
  CONFIRM_NOTIFICATION = 'CONFIRM_NOTIFICATION',
  ARCHIVE_NOTIFICATION = 'ARCHIVE_NOTIFICATION',

  REPLAY_EVENT = 'REPLAY_EVENT',

  NEUTRAL = 'NEUTRAL',
  OBJECTIVE_DESIGNATION = 'OBJECTIVE_DESIGNATION',
  OBJECTIVE_DESIGNATION_TERMINATION = 'OBJECTIVE_DESIGNATION_TERMINATION',

  CLEARANCE_CHANGE = 'CLEARANCE_CHANGE',
}

export enum EventActionEnum {
  EVENT_CREATION = 'EVENT_CREATION',
  EVENT_UPDATE = 'EVENT_UPDATE',
}

export type LogAction = UserActionEnum | SystemActionEnum | EventActionEnum;

export enum LogTypeEnum {
  EVENT = 'EVENT',
  INSTRUCTION = 'INSTRUCTION',
  USER_ACTION = 'USER_ACTION',
  SYSTEM = 'SYSTEM',
}
